import { render, staticRenderFns } from "./OauthSignIn.vue?vue&type=template&id=1b33122e"
import script from "./OauthSignIn.vue?vue&type=script&lang=js"
export * from "./OauthSignIn.vue?vue&type=script&lang=js"
import style0 from "./OauthSignIn.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports